﻿export default {
	actionContextSelector: "[data-action-context]",
	activeClass: "ccs-logo-ms365-active",

	wrapperSelector: ".ccs-logo-ms365-wrapper",
	contentsSelector: ".ccs-logo-ms365-inner",
	mainTabSelector: ".ccs-logo-ms365-main-tab",
	subTabSelector: ".ccs-logo-ms365-sub-tab",
	tabContentSelector: ".ccs-logo-ms365-tabcontent",
	cardsSelector: ".ccs-logo-ms365-cards",
	specsSelector: ".ccs-logo-ms365-specs",
	footerSelector: ".ccs-logo-ms365-footer",
	footerTextClass: "ccs-logo-ms365-footer-text",

	addToCartSelector: "[data-logo-addtocart]",
	priceSelector: "[data-logo-dynamic-price]",
	fakeAddToCartClass: "ccs-ms365-promo-fake-atc",

	wrapperPromoAttr: "data-promo",
	copyCodeEventAttr: "data-copy-code-event",
	promoContainerClass: "ccs-ms365-promo",
	promoBannerShowAttr: "data-show-popup",
	bannerClasses: {
		banner: "ccs-ms365-promo-banner",
		top: "ccs-ms365-promo-banner-top",
		bottom: "ccs-ms365-promo-banner-bottom"
	},
	popupClasses: {
		popup: "ccs-ms365-promo-popup",
		show: "ccs-ms365-popup-show",
		modalWindow: "ccs-ms365-promo-modal",
		closeBtn: "ccs-ms365-promo-close",
		content: "ccs-ms365-promo-content",
		picture: "ccs-ms365-promo-picture",
		title: "ccs-ms365-promo-title",
		description: "ccs-ms365-promo-desc",
		copyCodeBtn: "ccs-ms365-promo-copy-code-btn",
		couponCode: "ccs-ms365-promo-coupon-code"
	}
}
